import { AvatarImage } from "@/components/ui/avatar"
import { User as UserIcon, Bot } from "lucide-react"
export const getRoleDetails = (role: string, userAvatarImageUrl: string | null | undefined ) => {

  switch (role) {
    case "user":
      return {
        icon: userAvatarImageUrl ? <AvatarImage src={userAvatarImageUrl}/> : null,
        fallbackIcon: <UserIcon className="h-4 w-4" />,
        bgColor: "bg-primary", 
        textColor: "text-primary-foreground", 
        bubbleBg: "bg-secondary/25", 
        bubbleText: "text-foreground",
        bubbleRounded: "rounded-tr-none",
      }
    case "assistant":
    case "system":
    case "data":
      return {
        icon: <AvatarImage src="/brand/alan/favicon/alan-favicon-32x32.png"/>, 
        fallbackIcon: <Bot className="h-4 w-4" />,
        bgColor: "bg-muted", 
        textColor: "text-muted-", 
        bubbleBg: "bg-secondary/80", 
        bubbleText: "text-foreground",
        bubbleRounded: "rounded-tl-none",
      }
    default:
      return {
        icon: <Bot className="h-4 w-4" />,
        fallbackIcon:<AvatarImage src="/brand/alan/favicon/alan-favicon-32x32.png"/>, 
        bgColor: "bg-gray-100",
        textColor: "text-gray-700",
        bubbleBg: "bg-gray-100 dark:bg-gray-800",
        bubbleText: "text-gray-900 dark:text-gray-100",
        bubbleRounded: "",
      }
  }
}